export const activityTag = {
  comments: [
    {
      name: "You",
      dateTime: "01-11-2024 12:45:10",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    },
    {
      name: "Siddhant",
      dateTime: "01-12-2024 15:05:22",
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    },
  ],
  activities: [
    {
      dateTime: "12-27-2023 19:17:10",
      text: "Prasun assigned HR Admin role to Avneet Singh.",
    },
    {
      dateTime: "12-27-2023 19:15:10",
      text: "Prasun created a new user Avneet Singh",
    },
    {
      dateTime: "12-27-2023 15:17:10",
      text: "Prasun created a new role HR Admin",
    },
    {
      dateTime: "12-27-2023 14:17:10",
      text: "Prasun updated a role UI/UX Designer ‣ Product Designer",
    },
    {
      dateTime: "12-27-2023 14:17:10",
      text: "Amrit updated resources for UI/UX Designer role.",
    },
    {
      dateTime: "12-27-2023 14:17:10",
      text: "Amrit updated user Prashant Singh ‣ Prasun Singh",
    },
    {
      dateTime: "12-27-2023 14:17:10",
      text: "Amrit updated user Prashant Singh ‣ Prasun Singh",
    },
  ],
};
